// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-list td:nth-last-child(2) {
    text-align: right;
}

.file-list td:last-child {
    width: 90px;
}

.file-list tr:nth-child(odd) {
	background-color: #eef;
}`, "",{"version":3,"sources":["webpack://./src/css/file-table.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;CACC,sBAAsB;AACvB","sourcesContent":[".file-list td:nth-last-child(2) {\n    text-align: right;\n}\n\n.file-list td:last-child {\n    width: 90px;\n}\n\n.file-list tr:nth-child(odd) {\n\tbackground-color: #eef;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
